/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { type Signal, signal } from '@preact/signals-react'

import { type TAltchaState } from '@/interfaces'

const altcha: Signal<string | null> = signal(null)

export const AltchaState: TAltchaState = {
  altcha,
}
